<div class="z-40 shadow-sm" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
  <div class="bg-white dark:bg-[#0e1726]">
    <div class="relative flex w-full items-center px-5 py-2.5">
      <div class="horizontal-logo flex items-center justify-between lg:hidden ltr:mr-2 rtl:ml-2">
      <a routerLink="/" class="main-logo flex shrink-0 items-center">
        <img class="inline w-8 ltr:-ml-1 rtl:-mr-1"  src="/assets/favicon.png" alt />
        <span
          class="hidden align-middle text-2xl font-bold transition-all duration-300 dark:text-white-light lg:inline ltr:ml-1.5 rtl:mr-1.5">Source<span class="text-[#068CFE]">by</span></span>
      </a>

      <a href="javascript:;"
        class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden ltr:ml-2 rtl:mr-2"
        (click)="storeData.dispatch({type: 'toggleSidebar'})">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
          <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
          </path>
          <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
        </svg>
      </a>
    </div>

    <!-- Back Button and Page Title (shown for detail pages) -->
    @if ((headerConfig$ | async)?.showBackButton) {
    <div class="flex flex-1 items-center gap-2">
     
      <h2 class="text-lg font-semibold text-[#0E121B] dark:text-white">{{ (headerConfig$ | async)?.pageTitle }}
      </h2>
    </div>
    }
    <!-- Right side elements (always visible) -->
    <div class="flex items-center gap-2 ltr:ml-auto rtl:mr-auto">
      <!-- theme selector -->
      <div>
        @if (store.theme === 'light') {
        <a href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'dark'})">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="1.5"></circle>
            <path d="M12 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M12 20V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M4 12L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M22 12L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path opacity="0.5" d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round"></path>
            <path opacity="0.5" d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round"></path>
            <path opacity="0.5" d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round"></path>
            <path opacity="0.5" d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round"></path>
          </svg>
        </a>
        }
        @if (store.theme === 'dark') {
        <a href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'light'})">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.0672 11.8568L20.4253 11.469L21.0672 11.8568ZM12.1432 2.93276L11.7553 2.29085V2.29085L12.1432 2.93276ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM15.5 14.25C12.3244 14.25 9.75 11.6756 9.75 8.5H8.25C8.25 12.5041 11.4959 15.75 15.5 15.75V14.25ZM20.4253 11.469C19.4172 13.1373 17.5882 14.25 15.5 14.25V15.75C18.1349 15.75 20.4407 14.3439 21.7092 12.2447L20.4253 11.469ZM9.75 8.5C9.75 6.41182 10.8627 4.5828 12.531 3.57467L11.7553 2.29085C9.65609 3.5593 8.25 5.86509 8.25 8.5H9.75ZM12 2.75C11.9115 2.75 11.8077 2.71008 11.7324 2.63168C11.6686 2.56527 11.6538 2.50244 11.6503 2.47703C11.6461 2.44587 11.6482 2.35557 11.7553 2.29085L12.531 3.57467C13.0342 3.27065 13.196 2.71398 13.1368 2.27627C13.0754 1.82126 12.7166 1.25 12 1.25V2.75ZM21.7092 12.2447C21.6444 12.3518 21.5541 12.3539 21.523 12.3497C21.4976 12.3462 21.4347 12.3314 21.3683 12.2676C21.2899 12.1923 21.25 12.0885 21.25 12H22.75C22.75 11.2834 22.1787 10.9246 21.7237 10.8632C21.286 10.804 20.7293 10.9658 20.4253 11.469L21.7092 12.2447Z"
              fill="currentColor"></path>
          </svg>
        </a>
        }
        
      </div>   
      <!-- chats -->
      @if ((headerConfig$ | async)?.showActivities) {
      <div>
        <button routerLink="/chat"
          (click)="onNavLinkClick($event, '/chat')"
          class="relative block rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60">
          <icon-chat class="h-4 w-4"></icon-chat>
          @if (totalChatUnreadCount > 0) {
          <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
            <span
              class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[5px] rtl:-right-[5px]"></span>
            <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
          </span>
          }
        </button>
      </div>
      }
      <!-- notifications -->
      @if ((headerConfig$ | async)?.showActivities) {
      <div class="dropdown shrink-0">
        <div hlMenu>
          <button (click)="fetchNotifications()" type="button" hlMenuButton
            class="relative block rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60">
            <icon-notification class="h-4 w-4"></icon-notification>
            @if (hasUnreadNotifications) {
            <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
              <span
                class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[5px] rtl:-right-[5px]"></span>
              <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
            </span>
            }
          </button>
          @if (showActivityMenu()) {
          <ul *hlMenuItems @toggleAnimation
            class="custom-shadow top-10 w-[300px] z-[1000009] divide-y rounded-lg !py-0 text-dark dark:divide-white/10 dark:text-white-dark sm:w-[350px] ltr:-right-2 
            rtl:-left-2 relative">
            <li>
              <div class="w-full h-full flex items-center justify-between px-4 py-2 font-semibold">
                <div class="flex items-center gap-2">
                  <icon-notification1 class="h-4 w-4"></icon-notification1>
                  <h4 class="text-[16px] font-semibold text-primary">Notifications
                  </h4>
                </div>
                <div class="flex items-center gap-1">
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='all' }"
                    (click)="notificationType('all')">
                    All
                  </button>
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='read' }"
                    (click)="notificationType('read')">
                    Read
                  </button>
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='unread' }"
                    (click)="notificationType('unread')">
                    Unread
                  </button>
                </div>
              </div>
            </li>
            <app-notification [notifications]="notifications" [filteredNotifications]="filteredNotifications"
              (fetchNotifications)="fetchNotifications()"
              (closeNotificationPopup)="closeNotificationPopup()"></app-notification>
          </ul>
          }
        </div>
      </div>
      }
      @if (showTenantSwitcher) {
      <div class="dropdown shrink-0">
        <div hlMenu>
          <button hlMenuButton type="button"
            class="flex max-w-[180px] items-center gap-x-2 rounded-lg border border-gray-200 px-3 py-1.5 align-middle hover:shadow-inner dark:border-white/10">
            <span class="truncate text-[12px] font-medium">{{ getSelectedTenantName() }}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="shrink-0">
              <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </button>
          <ul *hlMenuItems @toggleAnimation
            class="top-9 z-50 min-w-[160px] text-xs ltr:right-0 rtl:left-0 2xl:text-[13px]">
            @for (option of tenantOptions; track option.value) {
            <li>
              <button type="button" *hlMenuItem="let menuItem"
                class="flex w-full cursor-pointer items-center px-3 py-2 text-left hover:bg-white-light/90 dark:hover:bg-dark/60"
                [ngClass]="{ 'bg-white-light/90 font-semibold dark:bg-dark/60': selectedTenant === option.value }"
                (click)="onTenantChange(option)">
                {{ option.label }}
              </button>
            </li>
            }
          </ul>
        </div>
      </div>
      }
     <app-vendor-header-timezone></app-vendor-header-timezone>
     <!-- currency dropdown -->
     <div class="dropdown">
      <div hlMenu>
        <a hlMenuButton href="javascript:;"
          class="flex items-center gap-x-2 rounded-lg border border-gray-200 px-3 py-1.5 align-middle hover:shadow-inner dark:border-white/10">
          @if (showCurrencyPlaceholder()) {
            <span class="border-0 border-[#d1d2d3] pr-0.5 dark:border-[#1b2e4b] md:border-r md:pr-2 lg:py-0">
              <span class="inline-flex h-3 w-3 items-center justify-center text-[12px] leading-none">{{ tenantCurrencySymbol }}</span>
            </span>
            <span class="hidden text-[12px] font-medium lg:block">{{ tenantCurrency }}</span>
          } @else {
            <span class="border-0 border-[#d1d2d3] py-1 pr-0.5 dark:border-[#1b2e4b] md:border-r md:pr-2 lg:py-0">
              <span class="inline-flex h-3 w-3 items-center justify-center text-[12px] leading-none">{{ currencySymbol() }}</span>
            </span>
            <span class="hidden text-[12px] font-medium lg:block">{{ currencyCode() }}</span>

          }
          <span class="hidden pl-0 lg:block lg:pl-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="ng-star-inserted inline-block ltr:ml-1 rtl:mr-1">
              <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            </svg>
          </span>
        </a>
        <ul *hlMenuItems @toggleAnimation class="top-9 min-w-[120px] text-xs 2xl:text-[13px] ltr:right-0 rtl:left-0 z-50">
          <li>
            <a class="flex cursor-pointer items-center gap-x-2  border-b border-[#E1E4EA] px-2 py-1.5"
              *hlMenuItem="let menuItem" (click)="clearCurrencySelection()">
              <span class="pr-0">{{tenantCurrencySymbol}}</span>
              <span class="border-l border-[#d1d2d3] pl-2 dark:border-[#1b2e4b]">{{tenantCurrency}}</span>
            </a>
          </li>
          @for (currency of currencies; track currency.code) {
          <li>
            <a class="flex cursor-pointer items-center gap-x-2" *hlMenuItem="let menuItem" (click)="changeCurrency(currency.symbol, currency.code)"><span
                class="border-r border-[#d1d2d3] pr-2 dark:border-[#1b2e4b]">{{ currency.symbol }}
                  </span>{{ currency.code }}</a>
          </li>
          }
        </ul>
      </div>
    </div>
    </div>
  </div>

    <!-- horizontal menu -->
    <ul
      class="relative horizontal-menu hidden w-full items-center border-t border-[#ebedf2] bg-white px-4 py-1.5 font-semibold text-black dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-1.5 xl:space-x-2 rtl:space-x-reverse">
      @for (item of tenantPermissionService.navigationItems(); track item.slug) {
      <li class="menu nav-item relative">
        <a [routerLink]="item.route" class="nav-link" routerLinkActive="active"
          (click)="onNavLinkClick($event, item.route)">
          <div class="flex items-center">
            @switch (item.icon) {
              @case ('dashboard') {
                <icon-menu-dashboard class="shrink-0 text-secondary"></icon-menu-dashboard>
              }
              @case ('event') {
                <icon-event class="shrink-0 text-secondary"></icon-event>
              }
              @case ('purchase-order') {
                <svg class="shrink-0 text-secondary" xmlns="http://www.w3.org/2000/svg" id="shopping-cart_3_" data-name="shopping-cart (3)" width="20" height="20.503" viewBox="0 0 20 20.503">
                  <path id="Path_27148" data-name="Path 27148" d="M19.4,3.483a2.557,2.557,0,0,0-1.967-.92H3.624l-.036-.3A2.563,2.563,0,0,0,1.044,0H.854a.854.854,0,0,0,0,1.709h.19a.854.854,0,0,1,.848.754l1.176,10A4.271,4.271,0,0,0,7.31,16.232h8.921a.854.854,0,0,0,0-1.709H7.31A2.563,2.563,0,0,1,4.9,12.814H15.084a4.272,4.272,0,0,0,4.2-3.514l.671-3.719a2.558,2.558,0,0,0-.555-2.1ZM18.282,5.278,17.61,9a2.563,2.563,0,0,1-2.526,2.108H4.629l-.8-6.834H17.436a.854.854,0,0,1,.846,1.006Z" fill="currentColor"/>
                  <circle id="Ellipse_1303" data-name="Ellipse 1303" cx="1.709" cy="1.709" r="1.709" transform="translate(4.271 17.086)" fill="currentColor"/>
                  <circle id="Ellipse_1304" data-name="Ellipse 1304" cx="1.709" cy="1.709" r="1.709" transform="translate(12.814 17.086)" fill="currentColor"/>
                </svg>
              }
              @case ('contract') {
                <svg class="shrink-0 text-secondary" xmlns="http://www.w3.org/2000/svg" width="20.515" height="19.434"
                  viewBox="0 0 20.515 19.434">
                  <path id="contracts"
                    d="M19.763,9.62a2.736,2.736,0,0,0-3.624,0L9.4,16v3.433h3.624l6.736-6.381a2.335,2.335,0,0,0,0-3.433Zm-1.205,2.292-6.232,5.9H11.121V16.672l6.232-5.9a.9.9,0,0,1,1.205,0,.791.791,0,0,1,0,1.15ZM1.71,2.429a.836.836,0,0,1,.855-.81H8.548V6.478h5.129V9.66l1.71-1.619v-2.7L9.753,0H2.564A2.507,2.507,0,0,0,0,2.429V17.814H7.693V16.195H1.71Zm8.548.332,2.214,2.1H10.258Zm1.667,8.559a2.854,2.854,0,0,0,.043-.389,1.284,1.284,0,0,0-2.564,0h0a3.529,3.529,0,0,0,.137,1,2.614,2.614,0,0,1-1,.219,2.672,2.672,0,0,1-1.282-.364A4.651,4.651,0,0,0,8.54,8.907,2.507,2.507,0,0,0,5.975,6.478,2.507,2.507,0,0,0,3.411,8.907a4.632,4.632,0,0,0,1.282,2.875,2.672,2.672,0,0,1-1.282.364v1.619a4.693,4.693,0,0,0,2.564-.85,4.693,4.693,0,0,0,2.564.85,4.755,4.755,0,0,0,.9-.1l2.479-2.348Zm-5.941-.6a3.178,3.178,0,0,1-.855-1.814.856.856,0,0,1,1.71,0A3.178,3.178,0,0,1,5.984,10.721Z"
                    fill="currentColor" />
                </svg>
              }
            }

            <span class="px-2">{{ item.label }}</span>
          </div>
        </a>
      </li>
      }
    
     
  
      <li class="absolute top-2 right-4 menu nav-item ltr:ml-auto rtl:mr-auto">
        <div class="relative dropdown shrink-0">
          <div hlMenu class="!block">
            <button type="button" hlMenuButton class="group relative block">
              @if(authService.isProfilePictureLoading() && !authService.getProfilePicture()){
              <div class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white dark:border-white/10 dark:bg-dark/40">
                <span class="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent"></span>
              </div>
              }@else if(authService.getProfilePicture()){
              <img [src]="authService.getProfilePicture()"
             [appFallbackImage]="imageService.getInitials(vendorData?.company_name)" [fallbackSize]="128"
                fallbackBgColor="#E3EAFD" fallbackTextColor="#2B3674" alt="Profile"
                class="h-8 w-8 rounded-full object-cover" (error)="authService.onImageError($event, vendorData?.company_name || VendorName || 'NA')" />
              }@else{
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full border-2  bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 dark:border-gray-600 sm:h-10 sm:w-10">
                <span class="text-xs font-semibold text-white shadow-sm"> {{
                  imageService.getInitials(VendorName || vendorData?.company_name || 'NA') }} </span>
              </div>
              }
            </button>
            <ul *hlMenuItems @toggleAnimation
                            class="absolute top-full right-0 z-50 w-[230px] !py-0 font-semibold text-primary mt-2">
                            <li>
                              <div class="flex items-center px-4 py-4">
                                <div class="flex-none">
                                  @if(authService.isProfilePictureLoading() && !authService.getProfilePicture()){
                                      <div class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white dark:border-white/10 dark:bg-dark/40">
                                        <span class="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent"></span>
                                      </div>
                                      }@else if(authService.getProfilePicture()){
                                      <img [src]="authService.getProfilePicture()"
                            [appFallbackImage]="imageService.getInitials(vendorData?.company_name)" [fallbackSize]="128"
                                      fallbackBgColor="#E3EAFD" fallbackTextColor="#2B3674" alt="Profile" 
                                      (error)="authService.onImageError($event, vendorData?.company_name)"
                                      class="h-8 w-8 rounded-full object-cover" />
                                      }@else{
                                      <div
                                        class="flex h-8 w-8 items-center justify-center rounded-full border-2  bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 dark:border-gray-600 sm:h-10 sm:w-10">
                                        <span class="text-xs font-semibold text-white shadow-sm">
                                          {{ imageService.getInitials(VendorName || vendorData?.company_name || 'NA') }}
                                        </span>
                                      </div>
  
                                    }
                                  </div>
                                  <div class="truncate ltr:pl-4 rtl:pr-4">
                                    <h4 class="text-base">{{ vendorData?.company_name || VendorName }}</h4>
                                    <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                                    href="javascript:;">{{ vendorData?.email_id || vendorLoginData?.email_id || '' }}</a>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <a routerLink="/vendor/profile"
                                  (click)="onNavLinkClick($event, '/vendor/profile')"
                                  class="cursor-pointer border-t border-gray-200 pt-2 text-primary dark:border-white/10">
                                  <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                                    <path opacity="0.5"
                                      d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                                      stroke="currentColor" stroke-width="1.5" />
                                    </svg>
  
                                    View Profile
                                  </a>
                                </li>
                                  <li class="border-t border-white-light dark:border-white-light/10">
                                    <a (click)="signOut()" class="cursor-pointer !py-3 text-primary">
                                      <svg class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2" width="18" height="18"
                                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.5"
                                          d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                                          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                          <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="currentColor"
                                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </svg>
                                          Sign Out
                                        </a>
                                      </li>
                       </ul>
          </div>
  
        </div>
      </li>
  
    </ul>
  </div>
</div>